import { client } from './client';

export const smsCampaignApi = {
  list: () => client.get('get_sms_campaigns'),
  get: (campaign_id) => client.get('get_sms_campaign', { params: { campaign_id } }),
  save: (data) => client.post('save_sms_campaign', data),
  remove: (id) => client.post('delete_sms_campaign', { id }),
  preview: (data) => client.post('preview_sms_campaign', data),
  send: (id) => client.post('send_sms_campaign', { id }),
  logs: (campaign_id) => client.get('get_sms_campaign_logs', { params: { campaign_id } }),
  searchRecipients: (type, q) => client.get('search_sms_recipients', { params: { type, q } }),
};
